import { render } from "./BaseChatDialog.vue?vue&type=template&id=0d2dd9c3&scoped=true"
import script from "./BaseChatDialog.vue?vue&type=script&lang=js"
export * from "./BaseChatDialog.vue?vue&type=script&lang=js"

import "./BaseChatDialog.vue?vue&type=style&index=0&id=0d2dd9c3&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2dd9c3"]])

export default __exports__